module.exports = __webpack_public_path__ + "img/logo3.725dcc2b.png";